import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function DoubleHelixIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 2C11 2 21 5 21 10C21 16 11 16 11 22C11 27 21 30 21 30"
          stroke={white[900]}
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M21 2C21 2 11 5 11 10C11 16 21 16 21 22C21 27 11 30 11 30"
          stroke={white[900]}
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <rect x="12" y="5" width="8" height="1.8" rx="0.9" fill={white[900]} />
        <rect
          x="11"
          y="9.5"
          width="10"
          height="1.8"
          rx="0.9"
          fill={white[900]}
        />
        <rect
          x="13"
          y="15.1"
          width="6"
          height="1.8"
          rx="0.9"
          fill={white[900]}
        />
        <rect
          x="13"
          y="19.1"
          width="6"
          height="1.8"
          rx="0.9"
          fill={white[900]}
        />
        <rect
          x="11"
          y="23.5"
          width="10"
          height="1.8"
          rx="0.9"
          fill={white[900]}
        />
        <rect
          x="12"
          y="27.2"
          width="8"
          height="1.8"
          rx="0.9"
          fill={white[900]}
        />
      </svg>
    </SvgIcon>
  );
}
